import { IComponentOptions } from 'angular';
import { WizardRouteViewController } from './wizard-route-view.controller';
import template from './wizard-route-view.component.html';

export const WizardRouteViewComponent = {
	controller: WizardRouteViewController,
	template
} as IComponentOptions;
